import React, { useEffect, useState } from 'react';


const LocationsMap = (props) => {
  const { 
    branches,
    selectedBranch
  } = props;
  const [ map, setMap ] = useState(null);
  const API_KEY = 'AIzaSyAP7PpsTBThRFMs0ynbxZgPcICQwdTMBQw';
  useEffect(() => {
    const lat = 37.341186087974485
    const lng = -121.79089342161896
    const zoom = 9

    var mapCanvas = document.getElementById('map-place-2');
    var mapOptions = {
      center: new google.maps.LatLng(lat,lng),
      zoom: zoom,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapId: '5614c50fd8a6e35e13c4142f',
    }
    var map = new google.maps.Map(mapCanvas, mapOptions)
    setMap(map)
    createMarkers(branches, map)
  },[])

  useEffect(() => {
    if(map && selectedBranch && selectedBranch.location) {

      const lat = selectedBranch.location.lat
      const lng = selectedBranch.location.long
      const zoom = 14
      map.setCenter(new google.maps.LatLng(lat,lng))
      map.setZoom(zoom)
    }else if(map){
      const lat = 37.341186087974485
      const lng = -121.79089342161896
      const zoom = 9
      map.setCenter(new google.maps.LatLng(lat,lng))
      map.setZoom(zoom)
    }
  },[selectedBranch])

  const createMarkers = async (branches, map) => {
    const {AdvancedMarkerElement, PinElement} = await google.maps.importLibrary("marker");
    Object.keys(branches).map(branch_key=> {
      const branch = branches[branch_key];

      (branch.locations||[]).map((location, i)=> {
        if(!location.lat || !location.long){
          
        }else {
          const pinBorder = new PinElement({
            borderColor: '#fff',
            background: '#F47A20',
            glyphColor: 'white',
            scale: 1.3
          });

          var marker = new AdvancedMarkerElement({
            position: { lat: location.lat, lng: location.long },
            title: location.title,
            map: map,
            gmpClickable: true,
            content: pinBorder.element
          });
          marker.addListener('click', ({ domEvent, latLng }) => {
            window.location.href = `/location/${branch.link[0]}`
          });
        }

      })
    })
  }
  return (
    <div id="map-place-2" style={{
      height: '100%',
    }}>
    </div>

  )
}

export default LocationsMap